import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SvgComponent } from '@components/svg.component';
import { ModalClearCacheComponent } from '@components/Modals/modal-clear-cache/modal-clear-cache.component';
import { AppRoutes } from '@helpers/app-routes';
import { TerminalService } from '@services/terminal.service';
import { HistoryService } from '@services/history.service';

@Component({
  selector: 'app-settings-page',
  imports: [TranslateModule, SvgComponent, ModalClearCacheComponent],
  templateUrl: './settings-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'block h-full' },
})
export class SettingsPageComponent {
  private readonly router = inject(Router);
  private readonly historyService = inject(HistoryService);
  private readonly terminalService = inject(TerminalService);

  readonly showClearCacheModal = signal(false);
  readonly dineInEnabled = signal(true);
  readonly takeawayEnabled = signal(false);

  readonly currentInstanceLabel = this.terminalService.currentInstanceLabel;

  goBack(): void {
    this.historyService.back();
  }

  switchInstance(): void {
    this.router.navigate([AppRoutes.chooseInstance]);
  }

  toggleDineIn(): void {
    this.dineInEnabled.update((value) => !value);
  }

  toggleTakeaway(): void {
    this.takeawayEnabled.update((value) => !value);
  }

  goToSessionList(): void {
    this.router.navigate([AppRoutes.sessionList]);
  }

  goToGeneralSettings(): void {
    this.router.navigate([AppRoutes.adminSettings]);
  }

  manageTerminalPermissions(): void {
    this.router.navigate([AppRoutes.adminSettings]);
  }

  openClearCacheModal(): void {
    this.showClearCacheModal.set(true);
  }

  closeClearCacheModal(): void {
    this.showClearCacheModal.set(false);
  }

  confirmClearCache(): void {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = `/${AppRoutes.scanPage}`;
  }
}
